import { useMemo } from 'react'

import { elementsOptions } from '@shared/stripe'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import getConfig from 'next/config'

import type { NextConfig } from 'next/config'

const { publicRuntimeConfig } = getConfig() as NextConfig

export interface StripeElementsProps {
  children: React.ReactNode
}

export const StripeElements: React.FC<StripeElementsProps> = ({ children }) => {
  const stripe = useMemo(() => {
    if (publicRuntimeConfig.STRIPE_PUBLISHABLE_KEY) {
      return loadStripe(publicRuntimeConfig.STRIPE_PUBLISHABLE_KEY)
    }
    return null
  }, [])

  return (
    <Elements options={elementsOptions} stripe={stripe}>
      {children}
    </Elements>
  )
}
